import queryString from 'query-string';

import { ListingApplicationListingType } from 'api/types/ListingApplicationListingType';
import { OrgDashboardApiListingApplication } from 'modules/orgDashboard/api/types/OrgDashboardApiListingApplication';
import { OrgDashboardApiListingApplicationMini } from 'modules/orgDashboard/api/types/OrgDashboardApiListingApplicationMini';
import { OrgDashboardApiListingApplicationStatus } from 'modules/orgDashboard/api/types/OrgDashboardApiListingApplicationStatus';
import { getJson, postJson } from 'utils/http';

export const fetchApplications = (
  orgId: string,
  params: {
    type: ListingApplicationListingType | null | undefined;
    id: string | null | undefined;
  },
): Promise<{
  count: number;
  listingApplications: OrgDashboardApiListingApplicationMini;
}> => {
  const qs = queryString.stringify(params);
  return getJson<{
    count: number;
    listingApplications: OrgDashboardApiListingApplicationMini;
  }>(`/data/orgdashboard/${orgId}/listing-applications?${qs}`);
};

export const fetchApplicationIds = (
  orgId: string,
  params: {
    id: string | null | undefined;
  },
): Promise<Array<{ id: string }>> => {
  const qs = queryString.stringify(params);
  return getJson<{ listingApplicationIds: Array<{ id: string }> }>(
    `/data/orgdashboard/${orgId}/listing-applications-ids?${qs}`,
  ).then(({ listingApplicationIds }) => listingApplicationIds);
};

export const fetchApplication: (arg0: {
  orgId: string;
  applicationId: string;
}) => Promise<OrgDashboardApiListingApplication> = ({ orgId, applicationId }) =>
  getJson<{ listingApplication: OrgDashboardApiListingApplication }>(
    `/data/orgdashboard/${orgId}/listing-applications/${applicationId}`,
  ).then(({ listingApplication }) => listingApplication);

export const createApplicationNote: (arg0: {
  note: string;
  orgId: string;
  applicationId: string;
}) => Promise<OrgDashboardApiListingApplication> = ({
  orgId,
  applicationId,
  ...data
}) =>
  postJson<{ listingApplication: OrgDashboardApiListingApplication }>(
    `/data/orgdashboard/${orgId}/listing-applications/${applicationId}/note`,
    data,
  ).then(({ listingApplication }) => listingApplication);

export const updateApplicationStatus: (arg0: {
  status: OrgDashboardApiListingApplicationStatus;
  orgId: string;
  applicationId: string;
}) => Promise<OrgDashboardApiListingApplication> = ({
  orgId,
  applicationId,
  ...data
}) =>
  postJson<{ listingApplication: OrgDashboardApiListingApplication }>(
    `/data/orgdashboard/${orgId}/listing-applications/${applicationId}/status`,
    data,
  ).then(({ listingApplication }) => listingApplication);
